<div id="toggle-dcs" class="grid mb-5">
  <div class="col-12">
    <h1 i18n>{{ isLockedOut ? "Enable": "Disable" }} DCS</h1>
    <p i18n>Here you can {{ isLockedOut ? "enable": "disable" }} the Login to the DCS. {{ isLockedOut ? "This will give access to DCS for all users": "If you disable access to DCS, non-administrative users will be unable to login." }} </p>
    <h3 i18n>Currently {{ isLockedOut ? "Disabled": "Enabled" }}</h3>

    @if (messageType) {
      @switch (messageType) {
        @case ('DCS_NOT_DISABLED') {
          <p-message severity="error" closable i18n>Access has not been disabled</p-message>
        }
        @case ('DCS_DISABLED') {
          <p-message severity="warn" closable i18n>Access to DCS has been disabled</p-message>
        }
        @case ('DCS_ENABLED') {
          <p-message severity="success" closable i18n>Access to DCS has been enabled</p-message>
        }
        @case ('INTERNAL_SERVER') {
          <p-message severity="error" closable i18n>An error trying to switch DCS access has occurred</p-message>
        }
      }
    }
  </div>
  <div class="row">
      <button (click)="toggleDCS()" class="p-button form-btn {{ isLockedOut ? 'enable-dcs': 'disable-dcs' }}" i18n>
          {{ isLockedOut ? "Enable" : "Disable" }} DCS</button>
  </div>

  <p-confirmDialog></p-confirmDialog>
</div>
